export const FESTIVE_DATE_LABEL = 'Dec 24, Dec 25, Dec 31';
